import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { TMapping, TWorkflowDefinition } from '@commenda/types';
import { MappingForm } from '../forms/AddEditMappingForm';

export const MappingModal = ({
  isOpen,
  onClose,
  mapping,
  onMappingChange,
  workflowDefinition,
  currentStepId,
}: {
  isOpen: boolean;
  onClose: () => void;
  mapping: TMapping | null;
  onMappingChange: (mapping: TMapping) => void;
  workflowDefinition: TWorkflowDefinition;
  currentStepId: string;
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="flex flex-col overflow-hidden">
        <DialogHeader>
          <DialogTitle>
            {mapping?.id ? 'Edit Mapping' : 'Add Mapping'}
          </DialogTitle>
        </DialogHeader>
        <div className="grow overflow-auto max-h-[80vh]">
          <MappingForm
            mapping={mapping}
            onMappingChange={(m) => {
              onMappingChange(m);
              onClose();
            }}
            onCancel={onClose}
            formContentClassName="p-6"
            formFooterClassName="p-6"
            workflowDefinition={workflowDefinition}
            currentStepId={currentStepId}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
